
  import { mapState } from 'vuex'

  export default {
    props: {
      totals: {
        type: Object,
        default: () => { },
      },
    },
  }
